export default {
  addToGoogleCalendarButton: 'Add to Google Calendar',
  addToCalendarButton: 'Download to calendar on device'
}